// Generated by scripts/build-ui-icons.mjs.
export { ListBullets as default } from "../ui/glyphs-5";
